import { links } from '@/mixins/help-page'

function createTask(name, id, page) {
  return {
    name,
    id,
    count: null,
    dependencies: [],
    page
  }
}

const planWorkflow = () => createTask('Plan workflow', 'plan-workflow', links.planWorkflow)
const requestPrice = () => createTask('Request price', 'request-prices', links.requestPrice)

const priceEntry = () => createTask('Price entry', 'price-entries', links.priceEntry)
const expiringLicenses = () => createTask('Expiring licenses', 'expiring-licenses', links.expiringLicenses)
const finalizeLicenses = () => createTask('Finalize licenses', 'finalize-licenses', links.finalizeLicenses)
const titleLists = () => createTask('Title lists', 'title-lists', links.titleLists)

const stakeholders = () => createTask('Stakeholders', 'stakeholders', links.stakeholders)
const evaluation = () => createTask('Evaluation', 'evaluations', links.evaluation)
const decision = () => createTask('Decision', 'decisions', links.decision)
const placeOrders = () => createTask('Place orders', 'place-orders', links.placeOrders)

const approveInvoices = () => createTask('Approve invoices', 'approve-invoices', links.approveInvoices)
const vendorPayments = () => createTask('Vendor payments', 'vendor-payments', links.vendorPayments)

const implementation = () => createTask('Implementation', 'implementations', links.implementation)
const informUsers = () => createTask('Inform users', 'inform-users', links.informUsers)

export const dashboardWorkflow = () => [
  { title: 'CONSIDERATION', tasks: [planWorkflow(), requestPrice()] },
  { title: 'NEGOTIATION', tasks: [priceEntry(), expiringLicenses(), finalizeLicenses(), titleLists()] },
  { title: 'DECISION', tasks: [stakeholders(), evaluation(), decision(), placeOrders()] },
  { title: 'INVOICING', tasks: [approveInvoices(), vendorPayments()] },
  { title: 'IMPLEMENTATION', tasks: [implementation(), informUsers()] }
]

export const subscriptionWorkflow = () => [
  { title: 'CONSIDERATION', tasks: [planWorkflow(), requestPrice()] },
  { title: 'NEGOTIATION', tasks: [priceEntry(), titleLists()] },
  { title: 'DECISION', tasks: [stakeholders(), evaluation(), decision(), placeOrders()] },
  { title: 'INVOICING', tasks: [approveInvoices(), vendorPayments()] },
  { title: 'IMPLEMENTATION', tasks: [implementation(), informUsers()] }
]

export const subscriptionTaskMap = {
  'plan-workflow': { sIndex: 0, tIndex: 0 },
  'request-prices': { sIndex: 0, tIndex: 1 },

  'price-entries': { sIndex: 1, tIndex: 0 },
  'title-lists': { sIndex: 1, tIndex: 1 },

  stakeholders: { sIndex: 2, tIndex: 0 },
  evaluations: { sIndex: 2, tIndex: 1 },
  decisions: { sIndex: 2, tIndex: 2 },
  'place-orders': { sIndex: 2, tIndex: 3 },

  'approve-invoices': { sIndex: 3, tIndex: 0 },
  'vendor-payments': { sIndex: 3, tIndex: 1 },

  implementations: { sIndex: 4, tIndex: 0 },
  'inform-users': { sIndex: 4, tIndex: 1 }
}

export const dashboardTaskMap = {
  'plan-workflow': { sIndex: 0, tIndex: 0 },
  'request-prices': { sIndex: 0, tIndex: 1 },

  'price-entries': { sIndex: 1, tIndex: 0 },
  'expiring-licenses': { sIndex: 1, tIndex: 1 },
  'finalize-licenses': { sIndex: 1, tIndex: 2 },
  'title-lists': { sIndex: 1, tIndex: 3 },

  stakeholders: { sIndex: 2, tIndex: 0 },
  evaluations: { sIndex: 2, tIndex: 1 },
  decisions: { sIndex: 2, tIndex: 2 },
  'place-orders': { sIndex: 2, tIndex: 3 },

  'approve-invoices': { sIndex: 3, tIndex: 0 },
  'vendor-payments': { sIndex: 3, tIndex: 1 },

  implementations: { sIndex: 4, tIndex: 0 },
  'inform-users': { sIndex: 4, tIndex: 1 }
}
